import styled from 'styled-components'

const StyledLinkCard = styled.div`
  border-radius: 6px;
  box-shadow: 0 3px 7px 0px #0000001c;

  .link-preview {
    height: 145px;
    position: relative;
    width: 100%;
    border: 1px solid #00000021;
    border-bottom: 0;
    border-radius: 6px 6px 0 0;

    img {
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      object-fit: cover;
      border-radius: 5px 5px 0 0;
    }
  }

  .link-details {
    padding: 22px;
    border: 1px solid #00000021;
    border-bottom: 0;

    .link-title {
      font-size: 1rem;
      font-weight: 700;
      letter-spacing: -.01rem;
      display: block;
      color: ${({ theme }) => theme.colors.gray[700]};
    }

    .link-description {
      font-size: 15px;
      line-height: 24px;
      margin-top: 1rem;
      display: block;
      color: ${({ theme }) => theme.colors.gray[500]};
    }
  }

  .link-actions {
    padding: 0 22px 22px 22px;
    display: grid;
    grid-gap: 6px;
    border: 1px solid #00000021;
    border-top: 0;
    border-radius: 0 0 6px 6px;

    .btn {
      width: 100%;

      &.details-btn {
        color: ${({ theme }) => theme.colors.green[400]};
        font-weight: 600;
        font-family: ${({ theme }) => theme.fonts.nunito};
      }

      &.copy-btn {
        background-color: ${({ theme }) => theme.colors.green[400]};
        color: ${({ theme }) => theme.colors.background};
      }
    }
  }
`

export default StyledLinkCard
